import styles from './snippet-carousel-item-bordered-more.module.scss'

export interface SnippetCarouselItemBorderedMoreProps {
  title?: string
}

export function SnippetCarouselItemBorderedMore(props: SnippetCarouselItemBorderedMoreProps) {
  const { title = 'Mais resultados' } = props
  return (
    <div className={styles.SnippetCarouselItemBorderedMore}>
      {title}
      <span className="icon icon-arrow-right" />
    </div>
  )
}
